import { useEffect, useRef } from 'react'
import uniqid from 'uniqid'
import { projects } from '../../portfolio'
import ProjectContainer from '../ProjectContainer/ProjectContainer'
import './Projects.css'

const Projects = () => {
  const gridRef = useRef(null)

  useEffect(() => {
    const grid = gridRef.current
    if (!grid) return () => {}

    const getGap = () => {
      const styles = window.getComputedStyle(grid)
      const rowGap = parseFloat(styles.rowGap)
      if (!Number.isNaN(rowGap)) return rowGap
      const gap = parseFloat(styles.gap)
      return Number.isNaN(gap) ? 0 : gap
    }

    const setRowSpans = () => {
      const rowHeight = 10
      const rowGap = getGap()
      const items = Array.from(grid.children)

      items.forEach((item) => {
        const { height } = item.getBoundingClientRect()
        const span = Math.ceil((height + rowGap) / (rowHeight + rowGap))
        const { style } = item
        style.gridRowEnd = `span ${span}`
      })
    }

    let frameId = 0
    const schedule = () => {
      if (frameId) cancelAnimationFrame(frameId)
      frameId = requestAnimationFrame(setRowSpans)
    }

    schedule()

    const resizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(schedule) : null
    if (resizeObserver) {
      Array.from(grid.children).forEach((item) => resizeObserver.observe(item))
    }

    const images = grid.querySelectorAll('img')
    images.forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', schedule)
        img.addEventListener('error', schedule)
      }
    })

    window.addEventListener('resize', schedule)

    return () => {
      window.removeEventListener('resize', schedule)
      images.forEach((img) => {
        img.removeEventListener('load', schedule)
        img.removeEventListener('error', schedule)
      })
      if (resizeObserver) resizeObserver.disconnect()
      if (frameId) cancelAnimationFrame(frameId)
    }
  }, [])

  if (!projects.length) return null

  return (
    <section id='projects' className='section projects'>
      <h2 className='section__title'>Experience</h2>

      <div className='projects__grid' ref={gridRef}>
        {projects.map((project, i) => (
          <ProjectContainer key={uniqid()} project={project} id={i} />
        ))}
      </div>
    </section>
  )
}

export default Projects
